// @flow

import React, { PureComponent } from 'react';
import i18n from 'app/common/lib/i18n';
import InterestQuery from 'app/common/react/components/growth/activation/HomefeedInterestUpsellHero/InterestQuery';
import { track } from 'app/common/lib/react/analytics';
import { Box, Heading, IconButton } from 'gestalt';

const COLUMN_WIDTH = 260;
const GUTTER_WIDTH = 24;
const PILL_BG_COLORS = ['#E2780D', '#F13535', '#133A5E'];

type Props = {|
  experienceId: number,
  header: string,
  handleComplete: () => void,
  handleDismiss: () => void,
  interests: Array<string>,
|};

export default class HomefeedInterestUpsellHero extends PureComponent<Props> {
  handleComplete = (interest: string) => {
    const { handleComplete } = this.props;
    handleComplete();
    track(PCONST.thrift.EventType.CLICK, {
      view: PCONST.thrift.ViewType.FEED,
      viewParameter: PCONST.thrift.ViewParameterType.FEED_HOME,
      component: PCONST.thrift.ComponentType.INTEREST_UPSELL_HOMEFEED_HERO,
      interest,
    });
  };

  renderInterestQuery = (interest: string, index: number) => (
    <InterestQuery
      key={interest}
      color={PILL_BG_COLORS[index]}
      interest={interest}
      onClick={this.handleComplete}
    />
  );

  render() {
    const { header, interests, handleDismiss } = this.props;

    return (
      <Box
        display="flex"
        justifyContent="center"
        marginTop={9}
        marginBottom={2}
        marginLeft={4}
        marginRight={4}
      >
        <Box minWidth={3 * COLUMN_WIDTH - GUTTER_WIDTH} maxWidth={3.5 * COLUMN_WIDTH}>
          <Box display="flex" direction="column" justifyContent="center">
            <Box display="flex" alignItems="start" justifyContent="between" marginBottom={3}>
              <Heading size="sm" overflow="normal">
                {header}
              </Heading>
              <IconButton
                icon="cancel"
                size="sm"
                accessibilityLabel={i18n._('close interests upsell hero', 'accessibility label')}
                onClick={handleDismiss}
              />
            </Box>
            <Box display="flex" alignItems="start" marginLeft={-1} marginRight={-1}>
              {interests.map(this.renderInterestQuery)}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}
